/**
 * Utility functions for standardizing Bank Data Structure in Support Portal
 */

export const getPaymentAccount = (userData, paymentMethod) => {
  if (!userData) return { name: "", accName: "", accNo: "", currency: "THB", isLocked: false };

  const pm = paymentMethod || userData.paymentMethod || "TH_BANK";
  const acc = userData.paymentAccounts?.[pm] || {};

  return {
    name: acc.name || (pm === "ALIPAY" ? "Alipay" : ""),
    accName: acc.accName || "",
    accNo: acc.accNo || "",
    currency: acc.currency || (pm === "LAO_BANK" ? "LAK" : pm === "ALIPAY" ? "CNY" : "THB"),
    qrUrl: acc.qrUrl || "",
    isLocked: false,
  };
};
